var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","fill":"none"}},_vm.$listeners),[_c('path',{attrs:{"fill":"currentColor","fill-rule":"evenodd","d":"M11.47 15.534 5.998 10.06 7.058 9 12 13.943 16.942 9l1.06 1.06-5.471 5.474a.75.75 0 0 1-1.061 0","clip-rule":"evenodd"}})])
}
var staticRenderFns = []

export default { render: render }